import React from 'react';

import PageIcon from '@atlaskit/icon/core/page';

export const ManagePagesIconV2 = () => <PageIcon label="" spacing="spacious" />;
